// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__140Ws","empty":"ModalGraph_empty__tspQE"};